import React, { useEffect } from 'react'
import RootStore from '../../store/Root'

interface Props {
    rootStore: RootStore
    destination: '/whitelabel-site' | '/qai-models'
}

const WLF_ADMIN_ORIGIN = 'https://wlfadmin.themccandlessgroup.com'

const LegacyWlfAdminRedirect: React.FC<Props> = ({ rootStore, destination }) => {
    const storedRole = window.localStorage.getItem('userRole')
    const role = rootStore.authStore.userRole || storedRole
    const isPartner = rootStore.authStore.isUserLoggedIn === true && role === 'PARTNER'

    useEffect(() => {
        if (!isPartner) {
            window.location.replace(`${WLF_ADMIN_ORIGIN}${destination}`)
        }
    }, [destination, isPartner])

    if (!isPartner) {
        return <main className='d-flex min-vh-100 align-items-center justify-content-center bg-body'>
            <div className='text-center' role='status' aria-live='polite'>
                <div className='spinner-border text-primary mb-3' aria-hidden='true'></div>
                <h1 className='h5 mb-2'>Opening Fleet Admin</h1>
                <p className='text-body-secondary mb-0'>Website operations now use the dedicated admin portal.</p>
            </div>
        </main>
    }

    return <main className='container py-5'>
        <section className='mx-auto border rounded-3 bg-body p-4 shadow-sm' style={{ maxWidth: '680px' }}>
            <p className='small fw-semibold text-uppercase text-primary mb-2'>Partner administration moved</p>
            <h1 className='h3 mb-3'>Open the admin area on your website.</h1>
            <p className='text-body-secondary mb-3'>Use your assigned website address followed by <code>/admin</code>. For example, <code>https://honeyz.ai/admin</code>.</p>
            <p className='mb-0'>Your existing partner email and password continue to work there.</p>
        </section>
    </main>
}

export default LegacyWlfAdminRedirect
